import { render } from "./AsRow.vue?vue&type=template&id=f3e45bfa&ts=true"
import script from "./AsRow.vue?vue&type=script&lang=ts"
export * from "./AsRow.vue?vue&type=script&lang=ts"

import "./AsRow.vue?vue&type=style&index=0&id=f3e45bfa&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__